import React, { useEffect, useState } from 'react';
import { TextField, Button, Select, MenuItem, Typography, FormControl, FormHelperText } from '@mui/material';
import InputField from 'packages/novous_web/src/common/components/InputField';
import AddDeviceForm from './components/AddDeviceForm';
import { ArrowBack } from '@mui/icons-material';
import { useNavigate, useParams } from 'react-router-dom';
import useAxios from 'packages/novous_web/src/api/useAxios';
import { API_ENDPOINTS } from 'packages/novous_web/src/api/endpoints';

const AddDevice: React.FC = () => {
    const navigate = useNavigate()
    const [deviceType, setDeviceType] = useState('FCW-DMS');
    const {id} = useParams();
    console.log('id', id);

    const {
        data: getDeviceData,
        error: getDeviceError,
        loading: getDeviceLoading,
        fetchData: fetchGetDeviceData,
      } = useAxios<{data: any}>(
        `${API_ENDPOINTS.directories.GET_DEVICE_DETAIL}/${id}`,
        "GET"
      );

      useEffect(()=>{
        if(id){
         fetchGetDeviceData();
        }
      },[id])
    

    return (
        <>
            <div className="mb-4 my-4">
                <button className="text-blue-600 font-medium flex items-center" onClick={() => navigate(-1)}>
                    <ArrowBack className="mr-1" /> Back
                </button>
            </div>
            <AddDeviceForm data={getDeviceData?.data} />
        </>


    );
};

export default AddDevice;
